import apis from '../../service/apis/couponGroupApi'
export const home = {
  namespaced: true,
  state: {
    'availableBalance': 0,
    'availableCouponNumber': 0,
    'sendCouponNumber': 0,
    'willExpireCouponNumber': 0
  },
  mutations: {
    getGroupInfoForHomePageSuccess (state, payload) {
      if (payload.res.data && Object.keys(payload.res.data).length > 0) {
        state.availableBalance = payload.res.data.availableBalance
        state.availableCouponNumber = payload.res.data.availableCouponNumber
        state.sendCouponNumber = payload.res.data.sendCouponNumber
        state.willExpireCouponNumber = payload.res.data.willExpireCouponNumber
      }
    }
  },
  actions: {
    getGroupInfoForHomePage ({ commit }, params) {
      apis.getGroupInfoForHomePage(params).then(res => {
        commit('getGroupInfoForHomePageSuccess', {res})
      })
    }
  }
}
